import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-createkicket',
  templateUrl: './createkicket.component.html',
  styleUrls: ['./createkicket.component.scss']
})
export class CreatekicketComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
